import type { UnknownOutputParams } from 'expo-router'

export const filterSearchParams = <T extends Record<string, string | undefined>>(
  searchParams: UnknownOutputParams,
): T => {
  const filtered = Object.entries(searchParams).reduce<Record<string, string | undefined>>((acc, [key, value]) => {
    if (value === 'undefined') return acc
    acc[key] = Array.isArray(value) ? value[0] : value
    return acc
  }, {})
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- caller-specified shape T
  return filtered as T
}
